<template>
  <div class="rank">
    <tabHeader
      :tabs="headTabs"
      @tabEvent="tabChange"
      :activeIndex="currentIndex"
    />

    <download @doOperate="doOperate" v-if="currentIndex == 'DOWNLOAD'" />
    <recharge @doOperate="doOperate" v-else />

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import tabHeader from "@/components/TabHeader";
import download from "./components/Download.vue";
import recharge from "./components/Recharge.vue";
import gamePlatPopup from "../../components/GamePlatPopup.vue";
import { mapGetters } from "vuex";
export default {
  name: "rank",
  components: {
    tabHeader,
    download,
    recharge,
    gamePlatPopup,
  },
  data() {
    return {
      headTabs: [
        {
          label: "下载榜",
          value: "DOWNLOAD",
        },
        {
          label: "充值榜",
          value: "RECHARGE",
        },
      ],
      currentIndex: "DOWNLOAD",
      gameInfo: {},
      btnType: "",
      gamePlatPopupVisible: false,
    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
  },
  methods: {
    tabChange(val) {
      this.currentIndex = val;
    },

    doOperate(scope, chennel) {
      // if(!this.isLogin) {
      //   this.$router.push('/login')
      //   return
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id
      };
      this.gamePlatPopupVisible = true;
    },
  },
};
</script>

<style lang="scss">
.rank {
  min-height: 100vh;

  .rank-container {
    height: 100%;
  }
  .rank-recharge-title,
  .rank-download-title {
    width: 100%;
    height: 404px;
    background: url("~@/assets/images/bg_xiazai_bang_1.png");
    background-size: 100% 100%;
  }
  .rank-recharge-title {
    background: url("~@/assets/images/bg_chongzhi_bang_1.png");
    background-size: 100% 100%;
  }
  .rank-recharge-title2,
  .rank-download-title2 {
    width: 100%;
    height: 100px;
    background: url("~@/assets/images/bg_xiazai_bang_2.png");
    background-size: 100% 100%;
  }
  .rank-recharge-title2 {
    background: url("~@/assets/images/bg_chongzhi_bang_2.png");
    background-size: 100% 100%;
  }
  .game-container,
  .game-container2 {
    background: #ff8215;
    padding-bottom: 43px;
    height: 100%;

    .game-box {
      width: 690px;
      background: #ffffff;
      border-radius: 20px;
      margin: 0 auto;
      margin-top: -80px;
      text-align: center;
    }
    .desc {
      padding: 34px 66px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #dfae8d;
    }
    .van-loading {
      min-height: calc(100vh - 644px);
    }
    .game-list {
      min-height: calc(100vh - 644px);
      .game-item {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 30px;
        padding: 0 23px 0 21px;
        &:last-child {
          padding-bottom: 30px;
        }
      }
      .game-item-top3 {
        padding: 34px 23px 34px 21px;
        background: #FDF6EF;
      }

      .game-item-content {
        display: flex;
        align-items: center;

        .sort-number-box {
          width: 30px;
          text-align: center;
          margin: 0 auto;
          margin-right: 18px;
        }

        .sort-number {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 30px;
          color: #a2a2a2;
          
        }
        .number-img {
          width: 20px;
          height: 28px;
        }

        .game-logo {
          width: 132px;
          height: 132px;
          margin-right: 20px;
        }
        .game-info {
          .game-info-title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            h1 {
              max-width: 250px;
              font-weight: 600;
              font-size: 32px;
              color: #000000;
              line-height: 45px;
              margin-right: 6px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            span {
              display: block;
              padding: 5px 5px;
              font-weight: 600;
              font-size: 22px;
              color: #ffffff;
              height: 30px;
              background: #ff7a3e;
              border-radius: 4px;
            }
          }
          .game-info-desc {
            width: 250px;
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .game-info-gift {
              span {
                padding: 4px 12px;
                background: #f8f8f8;
                border-radius: 4px;
                border: 1px solid #f8f8f8;
                font-weight: 500;
                font-size: 18px;
                color: #a2a2a2;
                margin-right: 8px;
              }
            }
            .star {
              display: flex;
              align-items: center;
              img {
                width: 24px;
                margin-right: 8px;
              }
            }
          }
          .game-tag {
            text-align: left;
            span {
              padding: 2px 6px;
              // background: #f8f8f8;
              border-radius: 22px;
              border: 0px solid #d2d2d2;
              font-weight: 600;
              font-size: 20px;
              color: #a2a2a2;
              // margin-right: 18px;
            }
            .other-tag {
              color: #ffbe70;
            }
          }
        }
      }

      .game-item-operate {
        span {
          display: block;
          width: 105px;
          height: 50px;
          border-radius: 25px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          line-height: 50px;
          text-align: center;

          &:first-child {
            color: #ffffff;
            background: #ff7a3e;
            margin-bottom: 23px;
          }
          &:last-child {
            border: 2px solid #ff7a3e;
            color: #ff7a3e;
          }
        }
      }
    }
  }
  .game-container2 {
    background: #fecc50;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/rank/index.vue